<template>
    <div v-if="!comics.length" class="flex justify-center">
        {{ $page.props.trans['messages.coming_soon'] }}...
    </div>
    <!-- eslint-disable max-len -->
    <div v-else class="grid gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div v-for="comic in comics"
             :key="comic.id"
             class="group relative flex flex-col bg-slate-800 border border-slate-300/10 rounded-b-3xl shadow">
            <div class="absolute -inset-[2px] rounded-b-3xl border-2 border-transparent opacity-0 [background:linear-gradient(var(--color-slate-800),var(--color-slate-800))_padding-box,linear-gradient(to_top,var(--color-indigo-400),var(--color-cyan-400),var(--color-sky-500))_border-box] group-hover:opacity-100"></div>
            <div class="relative">
                <!-- <i class="purchased far fa-star"></i> -->
                <!-- eslint-disable vue/attribute-hyphenation -->
                <inertia-link :href="route('comic_show', [$page.props.app.locale, comic.slug])"
                              :onSuccess="scrollToTop">
                    <img class="w-full"
                         :src="comic.thumbnail"
                         :alt="comic.title">
                </inertia-link>
                <!-- eslint-enable vue/attribute-hyphenation -->
                <div class="flex flex-1 flex-col p-5">
                    <h5 class="bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent text-lg text-center xl:text-xl">
                        {{ comic.title }}
                    </h5>
                    <div class="text-white text-sm text-center mb-5">
                        {{ comic.subtitle }}
                    </div>
                    <!-- eslint-disable vue/attribute-hyphenation -->
                    <inertia-link class="btn-sky font-semibold text-center mt-auto"
                                  :href="route('comic_show', [$page.props.app.locale, comic.slug])"
                                  :onSuccess="scrollToTop">
                        {{ $page.props.trans['messages.learn_more'] }}
                    </inertia-link>
                    <!-- eslint-enable vue/attribute-hyphenation -->
                </div>
            </div>
        </div>
    </div>
    <!-- eslint-enable max-len -->
</template>

<script setup>
import { nextTick, defineProps } from 'vue';

defineProps({
    comics: {
        type: Array,
        required: true
    }
});

const scrollToTop = () => {
    nextTick(() => {
        window.scrollTo(0, 0);
    });
};
</script>
